<app-snackbar></app-snackbar>
<div class="pl-l pb-l pr-l pt-l">
	<form [formGroup]="announcementForm">
		<div style="height: 100%; width: 75vw; max-width: 1500px;">
			<!-- Title -->
			<div class="disp-f j-c-sb a-i-c">
				<div class="disp-f a-i-c j-c-c">
					<div class="disp-f a-i-c j-c-c col bkg-light-grey-2 radius-10" style="height: 45px; width: 45px;">
						<img ngSrc="assets/icons/bullhorn.svg" class="svg-24" alt="" height="24" width="24">
					</div>
					<div class="ml-s flex-column gap-XS">
						<div *ngIf="mode === 'write'" class="font-L fw-700">{{ 'global.announcements.deployAnAnnouncement' | translate }}</div>
						<div *ngIf="mode === 'write'" class="font-M fw-300">{{ 'global.announcements.keepYourUserInformed' | translate }}</div>
						<div *ngIf="mode === 'read' && !_loading" class="font-L fw-700">{{ titleFormControl.value }}</div>
						<div *ngIf="mode === 'read' && !_loading" class="font-M fw-300">{{ typeFormControl.value?.name || '-' }}</div>
					</div>
				</div>
				<!-- Close button -->
				<app-icon-button (click)="onClose()" [img]="'assets/icons/close.svg'" type="stroked" background [panelClass]="'img-size-30 darken-icon'"></app-icon-button>
			</div>

			<!-- Content -->
			<div class="disp-f mt-l" style="height: 70vh;max-height: 600px;">
				<!-- Search & category -->
				<div class="disp-f f-d-col j-c-sb pr-l gap-L" style="flex: 1; max-height: 77vh; min-width: 300px;">
					<div *ngIf="!_loading" class="disp-f f-d-col gap-S" style="overflow-y: auto; overflow-x: hidden;">
						<app-text-input
							*ngIf="mode !== 'read'"
							[label]="'global.announcements.title' | translate"
							[input]="titleFormControl"
							[placeholder]="'global.announcements.titlePlaceholder' | translate">
						</app-text-input>
						<div class="flex-align-center gap-S">
							<div class="w-100">
								<label>{{ 'global.announcements.startDate' | translate }}</label>
								<div *ngIf="!data.announcement" class="flex-align-center custom-calendar-input c-p" (click)="startDatePicker.open()">
									<input class="h-100" [formControl]="startDateFormControl" [min]="minStartDate" [max]="maxStartDate" [matDatepicker]="startDatePicker">
									<div class="w-100 visible-input">{{ startDateFormControl.value ? (startDateFormControl.value|date:'dd/MM/YYYY') : '-' }}</div>
									<img class="c-p" src="assets/icons/calendar2.svg" alt="" width="18" height="18">
									<mat-datepicker #startDatePicker></mat-datepicker>
								</div>
								<div *ngIf="data.announcement" class="flex-align-center custom-calendar-input" [class.readonly-calendar]="mode === 'read'">
									<div class="w-100" [class.visible-input]="mode === 'write'" style="cursor: default">{{ startDateFormControl.value ? (startDateFormControl.value|date:'dd/MM/YYYY') : '-' }}</div>
									<img [style.display]="mode === 'read' ? 'none' : 'block'" src="assets/icons/calendar2.svg" alt="" width="18" height="18">
								</div>
							</div>
							<div class="w-100">
								<div class="flex-align-center">
									<label>{{ 'global.announcements.endDate' | translate }} </label>
									<div class="disp-f a-i-c j-c-c" style="height: 20px; width: 20px;"
										 [tooltip]="'global.announcements.endDateTooltip'|translate" tooltipPosition="right">
										<img src="assets/icons/help-3.svg" alt=""/>
									</div>
								</div>
								<div class="flex-align-center custom-calendar-input" [class.readonly-calendar]="mode === 'read'" [class.c-p]="mode === 'write'" (click)="openCalendar(endDatePicker)">
									<input class="h-100" [formControl]="endDateFormControl" [min]="minEndDate" [matDatepicker]="endDatePicker">
									<div class="w-100" [class.visible-input]="mode === 'write'">{{ endDateFormControl.value ? (endDateFormControl.value|date:'dd/MM/YYYY') : '-' }}</div>
									<div (click)="endDateFormControl.setValue(undefined)" *ngIf="endDateFormControl.value && mode === 'write'" class="delete-text-button mr-xs">
										<div class="flex-center h-100">
											<img src="assets/icons/close.svg" alt="">
										</div>
									</div>
									<img [style.display]="mode === 'read' ? 'none' : 'block'" class="c-p" src="assets/icons/calendar2.svg" alt="" width="18" height="18">
									<mat-datepicker #endDatePicker></mat-datepicker>
								</div>
							</div>
						</div>
						<div>
							<label>{{ 'global.announcements.type' | translate }}</label>
							<app-multi-select [width]="500" [inputControl]="typeFormControl" [readonly]="mode === 'read'">
								<app-select-trigger [readonly]="mode === 'read'" appearance="field">{{ typeFormControl.value?.name || '-' }}</app-select-trigger>
								<app-select-option *ngFor="let type of announcementTypeChoices" [value]="type">
									<div class="flex-align-center gap-M" style="white-space: normal">
										<div class="announcement-type-bubble flex-center">
											<img *ngIf="type.id === AnnouncementType.GENERAL" class="filter-accent" src="assets/icons/message-alert-square.svg" width="24">
											<img *ngIf="type.id === AnnouncementType.SENSITIZATION" class="filter-accent" src="assets/icons/sensitization_announcement.svg" width="24">
										</div>
										<div class="flex-column flex-align-start flex-justify-center gap-XS">
											<span class="fw-700 primary">{{ type.name }}</span>
											<span class="grey">{{ type.subtitle }}</span>
										</div>
									</div>
								</app-select-option>
							</app-multi-select>
						</div>
						<div>
							<label *ngIf="typeFormValue?.id === AnnouncementType.GENERAL">{{ 'global.announcements.target' | translate }}</label>
							<label *ngIf="typeFormValue?.id === AnnouncementType.SENSITIZATION">{{ 'global.announcements.application' | translate }}</label>
							<app-multi-select #multiSelect1 [readonly]="mode === 'read'" *ngIf="typeFormValue?.id === AnnouncementType.GENERAL" class="w-100" [inputControl]="teamsFormControl" multiple [addMinHeight]="true">
								<app-select-trigger [readonly]="mode === 'read'" appearance="field">{{!announcementForm.get(form.teams)!.value.length ? '-' : (announcementForm.get(form.teams)!.value[0].name  + ($any(announcementForm.get(form.teams)).value.length > 1 ? ' (+' + ($any(announcementForm.get(form.teams)).value.length - 1) + ')' : ''))}}</app-select-trigger>
								<app-select-search [searchControl]="searchTeamControl"></app-select-search>-->
								<app-select-option-group *ngFor="let group of filteredOrganizations" [label]="group.organization.name" noOptionPrefix>
									<app-select-option *ngFor="let org of group.children" [value]="org.organization">
										<div class="flex-align-center gap-M">
											<img [src]="!org.organization.icon ? 'assets/icons/team.svg' : ('/assets/icons/team_icon/' + org.organization.icon + '.svg')" class="filter-accent" height="16px">
											<span>{{org.organization.name}}</span>
										</div>
									</app-select-option>
								</app-select-option-group>
							</app-multi-select>

							<app-multi-select #multiSelect2 [readonly]="mode === 'read'" *ngIf="typeFormValue?.id === AnnouncementType.SENSITIZATION" class="w-100" [inputControl]="appFormControl" [addMinHeight]="true">
								<app-select-trigger [readonly]="mode === 'read'" appearance="field">
									<app-display-application *ngIf="appFormValue" [application]="appFormValue"></app-display-application>
									<span *ngIf="!appFormValue">-</span>
								</app-select-trigger>
								<app-select-search [searchControl]="searchAppControl"></app-select-search>-->
								<app-select-option *ngFor="let app of filteredApps" [value]="app">
									<app-display-application [application]="app"></app-display-application>
								</app-select-option>
							</app-multi-select>
						</div>
						<app-text-area [readonly]="mode === 'read'" [label]="'global.announcements.content' | translate" [rows]="11" [input]="contentFormControl" [placeholder]="('global.announcements.contentPlaceholder.1' | translate) + '&#10;&#10;' + ('global.announcements.contentPlaceholder.2' | translate) + '&#10;&#10;' + ('global.announcements.contentPlaceholder.3' | translate) + '&#10;&#10;' + ('global.announcements.contentPlaceholder.4' | translate) + '&#10;&#10;'"></app-text-area>
					</div>
					<div *ngIf="_loading" class="disp-f f-d-col gap-L" style="overflow: auto">
						<div>
							<app-list-loader [rowCount]="7"></app-list-loader>
						</div>
					</div>
					<div class="disp-f a-i-c j-c-c gap-L">
						<app-text-button class="w-100" type="stroked"
										 *ngIf="mode === 'write'"
                                         (click)="onClose()">{{ 'global.announcements.cancel' | translate }}</app-text-button>
						<app-text-button class="w-100" type="stroked"
										 *ngIf="mode === 'read'"
										 (click)="onClose()">{{ 'global.close' | translate }}</app-text-button>
						<app-text-button class="w-100" type="flat"
										 *ngIf="tenant && mode === 'read' && tenant.configuration.role !== 'read_only'"
										 (click)="setWriteMode()">{{ 'global.announcements.editThisAnnouncement' | translate }}</app-text-button>
						<app-text-button *ngIf="mode === 'write'" class="w-100" type="flat" [disabled]="announcementForm.invalid" [loading]="_saving"
                                         (click)="save()">{{ (!data.announcement ? 'global.announcements.publish' : 'global.announcements.update') | translate }}</app-text-button>
					</div>
				</div>
				<div class="disp-f f-d-col a-i-c preview-box gap-XXL"  style="padding: 30px; max-height: 70vh; overflow: auto; flex: 2; box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.08) inset;">
					<div class="disp-f" id="screens-container" style="height: 100%; margin: auto; gap: 60px; min-height: 400px;">
						<!-- FIRST SCREEN PREVIEW -->
						<div class="screen-preview" id="screen-1" style="height: fit-content">
							<div>
								<!-- HEADER -->
								<div class="rover-header-container">
									<div class="w-50 rover-header">
										<div class="disp-f a-i-c j-c-c" style="width: 20px; height: 20px;">
											<img class="filter-grey" ngSrc="assets/icons/close.svg" height="9" width="9" alt="">
										</div>
										<div class="disp-f a-i-c j-c-c">
											<img ngSrc="{{ tenantSettings && tenantSettings!.publicLogoUrl !== null ? tenantSettings?.publicLogoUrl : environment.applicationLogo }}" height="25" width="25" alt="">
										</div>
									</div>
								</div>
								<!-- BODY -->
								<div class="rover-body p-relative" style="padding: 20px;">
									<div class="announcement-list" style="margin-top: 0;">
										<div class="disp-f a-i-c j-c-sb">
											<div class="disp-f a-i-c j-c-c gap-M w-100">
												<!-- LOGO BUBBLE -->
												<div class="logo-bubble">
													<img *ngIf="typeFormValue?.id === AnnouncementType.GENERAL" class="filter-accent" ngSrc="assets/icons/message-alert-square.svg" height="20" width="20" alt="">
													<img *ngIf="typeFormValue?.id === AnnouncementType.SENSITIZATION" class="filter-accent" ngSrc="assets/icons/sensitization_announcement.svg" height="20" width="20" alt="">
												</div>
												<!-- NAME AND DATE -->
												<div class="flex-column gap-XS w-100 overflow-hidden">
													<span *ngIf="titleFormControl.valid || mode === 'read'" class="font-S fw-700" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
														{{ titleFormValue }}
													</span>
													<span *ngIf="titleFormControl.invalid && mode !== 'read'" class="font-S fw-700" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
														{{ 'global.announcements.titlePlaceholder' | translate }}
													</span>
													<span class="font-S fw-500">{{ 'global.announcements.datePlaceholder' | translate }}</span>
												</div>
												<div class="disp-f a-i-c j-c-c" style="height: 100%;">
													<img class="filter-grey" style="transform: rotate(90deg);" ngSrc="assets/icons/arrow-right-black.svg" height="14" width="14" alt="">
												</div>
											</div>
										</div>
										<div class="announcement-content font-S fw-500" style="max-height: 300px; overflow: auto" *ngIf="contentFormControl.valid || mode === 'read'">
											{{ contentFormValue }}
										</div>
										<div class="announcement-content font-S fw-500" *ngIf="contentFormControl.invalid && mode !== 'read'">
											{{ 'global.announcements.contentPlaceholder.1' | translate }}<br><br>
											{{ 'global.announcements.contentPlaceholder.2' | translate }}<br><br>
											{{ 'global.announcements.contentPlaceholder.3' | translate }}<br><br>
											{{ 'global.announcements.contentPlaceholder.4' | translate }}
										</div>
									</div>
									<div class="note-app gap-XS p-absolute flex-center pad-XS">
										<div style="width: 17px; height: 17px;">
											<img src="assets/icons/thumb-up.svg" class="filter-lightgrey" width="17">
										</div>
										<div style="height: 20px; width: 1px; background: #F7F8FA;"></div>
										<div style="width: 17px; height: 17px;">
											<img src="assets/icons/thumb-down.svg" class="filter-lightgrey" width="17">
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- SECOND SCREEN PREVIEW -->
						<div class="screen-preview h-90 disp-f f-d-col j-c-sb" style="min-height: 400px; height: auto">
							<div style="overflow: hidden;">
								<!-- HEADER -->
								<div class="rover-header" style="border-bottom: 1px solid #F2F2F7;">
									<div class="disp-f a-i-c j-c-c" style="width: 20px; height: 20px;">
										<img class="filter-grey" ngSrc="assets/icons/close.svg" height="9" width="9" alt="">
									</div>
									<div class="disp-f a-i-c j-c-c">
										<img ngSrc="{{ tenantSettings && tenantSettings!.publicLogoUrl !== null ? tenantSettings?.publicLogoUrl : environment.applicationLogo }}" height="25" width="25" alt="">
									</div>
									<div class="disp-f j-c-c a-i-c">
										<img ngSrc="assets/icons/rover-toggle.svg" height="20" width="37" alt="">
									</div>
								</div>
								<!-- BODY -->
								<div class="rover-body">
									<span class="font-S fw-700 mb-l">{{ 'global.announcements.lastAlerts' | translate }}</span>
									<div class="announcement-list">
										<div class="disp-f a-i-c j-c-sb">
											<div class="disp-f a-i-c j-c-c gap-M w-100">
												<!-- LOGO BUBBLE -->
												<div class="logo-bubble">
													<img *ngIf="typeFormValue?.id === AnnouncementType.GENERAL" class="filter-accent" ngSrc="assets/icons/message-alert-square.svg" height="20" width="20" alt="">
													<img *ngIf="typeFormValue?.id === AnnouncementType.SENSITIZATION" class="filter-accent" ngSrc="assets/icons/sensitization_announcement.svg" height="20" width="20" alt="">
												</div>
												<!-- NAME AND DATE -->
												<div class="flex-column gap-XS w-100 overflow-hidden">
													<span *ngIf="titleFormControl.valid || mode === 'read'" class="font-S fw-700" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
														{{ titleFormValue }}
													</span>
													<span *ngIf="titleFormControl.invalid && mode !== 'read'" class="font-S fw-700" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
														{{ 'global.announcements.titlePlaceholder' | translate }}
													</span>
													<span class="font-S fw-500">{{ 'global.announcements.datePlaceholder' | translate }}</span>
												</div>
												<div class="disp-f a-i-c j-c-c" style="height: 100%;">
													<img class="filter-grey" style="transform: rotate(90deg);" ngSrc="assets/icons/arrow-right-black.svg" height="14" width="14" alt="">
												</div>
											</div>
										</div>
										<div class="announcement-content font-S fw-500" style="max-height: 300px; overflow: auto;" *ngIf="contentFormControl.valid || mode === 'read'">
											{{ contentFormValue }}
										</div>
										<div class="announcement-content font-S fw-500" *ngIf="contentFormControl.invalid && mode !== 'read'">
											{{ 'global.announcements.contentPlaceholder.1' | translate }}<br><br>
											{{ 'global.announcements.contentPlaceholder.2' | translate }}<br><br>
											{{ 'global.announcements.contentPlaceholder.3' | translate }}<br><br>
											{{ 'global.announcements.contentPlaceholder.4' | translate }}
										</div>
										<div *ngFor="let _ of [].constructor(2)" class="disp-f a-i-c j-c-sb">
											<div class="disp-f a-i-c j-c-c gap-M w-100">
												<!-- LOGO BUBBLE -->
												<div class="loading-bubble"></div>
												<!-- NAME AND DATE -->
												<div class="disp-f f-d-col j-c-c w-100 gap-S" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
													<div class="announcement-name-loading"></div>
													<div class="announcement-date-loading"></div>
												</div>
												<div class="disp-f a-i-c j-c-c" style="height: 100%;">
													<img class="filter-grey" ngSrc="assets/icons/arrow-right-black.svg" height="14" width="14" alt="">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="disp-f">
								<!-- FOOTER -->
								<div class="rover-footer">
									<div>
										<img ngSrc="assets/icons/rover/home.svg" height="24" width="24" alt="">
									</div>
									<div>
										<img ngSrc="assets/icons/rover/apps.svg" height="24" width="24" alt="">
									</div>
									<div class="disp-f a-i-c j-c-c f-d-col" style="gap: 2px;">
										<img ngSrc="assets/icons/rover/bell.svg" height="24" width="24" alt="">
										<div class="bottom-bar"></div>
									</div>
									<div>
										<img ngSrc="assets/icons/rover/settings.svg" height="24" width="24" alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="preview-btn flex-center">
						<span class="grey">Prévisualisation</span>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
